import service from '@/utils/request'; // CreateBairunUserGroup 创建用户群
// @Tags UserInfo
// @Summary 创建用户群
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunUserGroupRequest true "创建用户群"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/userGroup/create [post]

export var createBairunUserGroup = function createBairunUserGroup(data) {
  return service({
    url: '/userManage/userGroup/create',
    method: 'post',
    data: data
  });
}; // DeleteBairunUserGroup 删除用户群
// @Tags UserInfo
// @Summary 删除用户群
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunUserGroupRequest true "删除用户群"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"删除成功"}"
// @Router /userManage/userGroup/delete [delete]

export var deleteBairunUserGroup = function deleteBairunUserGroup(data) {
  return service({
    url: '/userManage/userGroup/delete',
    method: 'post',
    data: data
  });
}; // DeleteBairunUserGroupByIds 批量删除用户群
// @Tags UserInfo
// @Summary 批量删除用户群
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "批量删除用户群"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"批量删除成功"}"
// @Router /userManage/userGroup/deleteByIds [delete]

export var deleteBairunUserGroupByIds = function deleteBairunUserGroupByIds(data) {
  return service({
    url: '/userManage/userGroup/deleteByIds',
    method: 'post',
    data: data
  });
}; // UpdateBairunUserGroup 更新用户群
// @Tags UserInfo
// @Summary 更新用户群
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunUserGroupRequest true "更新用户群"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /userManage/userGroup/update [put]

export var updateBairunUserGroup = function updateBairunUserGroup(data) {
  return service({
    url: '/userManage/userGroup/update',
    method: 'put',
    data: data
  });
}; // FindBairunUserGroup 用id查询用户群
// @Tags UserInfo
// @Summary 用id查询用户群
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunUserGroupRequest true "用id查询用户群"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /userManage/userGroup/find [get]

export var findBairunUserGroup = function findBairunUserGroup(params) {
  return service({
    url: '/userManage/userGroup/find',
    method: 'get',
    params: params
  });
}; // GetBairunUserGroupList 分页获取用户群数据
// @Tags UserInfo
// @Summary 分页获取用户群数据
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunUserGroupSearch true "分页获取用户群数据"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/userGroup/getList [get]

export var getBairunUserGroupList = function getBairunUserGroupList(params) {
  return service({
    url: '/userManage/userGroup/getList',
    method: 'get',
    params: params
  });
};
export var getBairunUserGroupInfoAllListByLevel = function getBairunUserGroupInfoAllListByLevel(params) {
  return service({
    url: '/userManage/userGroup/getListByLevel',
    method: 'get',
    donNotShowLoading: params.donNotShowLoading ? params.donNotShowLoading : true,
    params: params
  });
}; // getBairunUserGroupAuditList 分页获取用户群审批记录
// @Tags UserInfo
// @Summary 分页获取用户群审批记录
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.getBairunUserGroupAuditList true "分页获取用户群数据"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/userGroupAudit/getList [get]

export var getBairunUserGroupAuditList = function getBairunUserGroupAuditList(params) {
  return service({
    url: '/userManage/userGroupAudit/getList',
    method: 'get',
    params: params
  });
}; // userGroupAuditCheck 用户群申请审核
// @Tags UserInfo
// @Summary 用户群申请审核
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.userGroupAuditCheck true "创建用户群"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/userGroupAudit/check [post]

export var userGroupAuditCheck = function userGroupAuditCheck(data) {
  return service({
    url: '/userManage/userGroupAudit/check',
    method: 'post',
    data: data
  });
}; // getCarGroupList 营运车群组列表
// @Tags UserInfo
// @Summary 营运车群组列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.getCarGroupList true "营运车群组列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/userGroup/platform/list [post]

export var getCarGroupList = function getCarGroupList(data) {
  return service({
    url: '/userManage/userGroup/platform/list',
    method: 'post',
    data: data
  });
}; // changeUserGroup 变更用户所属群组
// @Tags UserInfo
// @Summary 变更用户所属群组
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.changeUserGroup true "变更用户所属群组"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/userGroupDetail/change [post]

export var changeUserGroup = function changeUserGroup(data) {
  return service({
    url: '/userManage/userGroupDetail/change',
    method: 'post',
    data: data
  });
};